import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {FileUpload, FileUploadErrorEvent} from "primereact/fileupload";
import {useParams} from "react-router-dom";
import {Ajax} from "../../utils/Ajax";
import {Image} from "primereact/image";
import CustomView from "../../component/CustomView";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";

import styles from './Restaurante.module.css';
import semImagem from '../../assets/semimagem.png';

import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import RestauranteCardapioItem from "../../model/RestauranteCardapioItem";
import {Card} from "primereact/card";
import RestauranteCardapioBebidaItem from "../../model/RestauranteCardapioBebidaItem";
import rest from "../../utils/EnvConfig";
import RestauranteCardapioBebida from "../../model/RestauranteCardapioBebida";
import Texto from "../../component/form/texto/Texto";
import {useKeycloak} from "../../keycloak/useKeycloak";

function RestauranteCardapioBebidaImagemEdit() {
    const {token} = useKeycloak();
    const {uuid} = useParams();
    const {info, error} = useContext(MensagemContext) as MensagemContextType;
    const [cardapioBebida, setCardapioBebida] = useState<RestauranteCardapioBebida>(new RestauranteCardapioBebida());
    const [pesquisa, setPesquisa] = useState<string>("");
    const recursoRestauranteCompletoRest = `${rest.restauranteCardapioBebida}/${rest.obterPorId}/`;
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        Ajax.of()
            .setTokenKeycloak(token!)
            .obterPorUuidCustom(recursoRestauranteCompletoRest, uuid ?? "", (data: RestauranteCardapioBebida) => {
            setCardapioBebida(data);
        });
    }, [])

    const onUpload = () => {
        Ajax.of()
            .setTokenKeycloak(token!)
            .obterPorUuidCustom(recursoRestauranteCompletoRest, uuid ?? "", (data: RestauranteCardapioBebida) => {
            setCardapioBebida(data);
        });
    };

    const onUploadError = (event: FileUploadErrorEvent) => {
        console.log(event);
    }

    const titulo = (): string => {
        if (cardapioBebida) {
            return `Cardápio: ${cardapioBebida.nomeCardapio}`;
        }
        return "";
    }

    const confirmarRegistro = async (rowData: RestauranteCardapioBebidaItem) => {
        setLoading(true);

        await Ajax.of()
            .error(error)
            .info(info)
            .setTokenKeycloak(token!)
            .removerRegistroCustom(`${rest.restauranteCardapioBebida}${rest.restauranteCardapioImagemRemover}${rowData.uuid}`, (data) => {
                if (cardapioBebida && cardapioBebida.itens) {
                    rowData.imagem = undefined;
                    setCardapioBebida({...cardapioBebida, itens: [...cardapioBebida.itens.filter(c => c.uuid !== rowData.uuid), rowData]});
                }
                setLoading(false);
            }, () => setLoading(false));
    };

    const removerRegistroConfirm = async (rowData: RestauranteCardapioItem) => {
        confirmDialog({
            message: 'Tem certeza que deseja remover essa imagem?',
            header: 'Atenção',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: "Sim",
            rejectLabel: "Não",
            async accept() {
                await confirmarRegistro(rowData);
            }
        });
    };

    const onPesquisar = (e: any) => {
        setPesquisa(e.target.value);
    }

    return (
        <>
            <CustomView id={`${rest.restauranteCardapioBebida}`} mostrarBarraBotoes={true} title={titulo()}>

                <div className={`${styles.espacamento} p-fluid grid`}>
                    <div className={"field col-12 md:col-8"}>
                        <div className={styles.textoExplicativo}>Insira somente uma foto para cada item do cardápio.</div>
                    </div>
                    <div className={"field col-12 md:col-4"}>
                        <Texto id={"pesquisa"} label={"Pesquisa"}
                               fullSize={true} placeholder={"Ex: sucos"}
                               value={pesquisa} onChangeHandler={onPesquisar}/>
                    </div>
                </div>

                <div className="flex grid">
                    {cardapioBebida && cardapioBebida.itens && cardapioBebida.itens.length > 0 ?
                        cardapioBebida.itens
                            .filter(item => pesquisa === ""
                                        || item.nome?.toLowerCase().includes(pesquisa.toLowerCase())
                                        || item.grupo?.nome?.toLowerCase().includes(pesquisa.toLowerCase()))
                            .map(cardapio =>
                            (
                                <div key={cardapio.uuid} className={"col-4"}>
                                    <Card title={`${cardapio.grupo?.nome} - ${cardapio.nome}`}
                                          className={styles.cardImagemCardapio}>
                                        <div className={"col"}>
                                            {cardapio.imagem ?
                                                (
                                                    <center>
                                                        <Image
                                                            src={`${rest.server}${rest.restauranteCardapioBebida}${rest.restauranteCardapioImagemObterPorId}${cardapio.uuid}`}
                                                            className={"p-2"} preview={true} loading={"lazy"}
                                                            alt="Image" width="250" height="140"/>
                                                    </center>
                                                ) : (
                                                    <div>
                                                        <center><img src={semImagem} alt={"Sem imagem"}
                                                                     width="150" height="140"/></center>
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className={`col-12 ${styles.botaoRemoverImagemAlinhamento}`}>
                                            <FileUpload mode="basic" multiple={false} name="fotos"
                                                        className={styles.botaoRemoverImagemCardapio}
                                                        url={`${rest.server}${rest.restauranteCardapioBebida}${rest.restauranteCardapioImagemUpload}${cardapio.uuid}`}
                                                        onUpload={onUpload} onError={onUploadError}
                                                        accept="image/*" maxFileSize={5242880} auto
                                                        chooseLabel="Adicionar foto"/>

                                            <Button label={"Remover"} icon={PrimeIcons.TRASH}
                                                    severity={"danger"}
                                                    loading={loading}
                                                    onClick={async () => await removerRegistroConfirm(cardapio)}
                                                    className={styles.botaoRemoverImagemCardapio}/>
                                        </div>
                                    </Card>
                                </div>
                            )
                        ) : (<div><h3>Nenhuma imagem cadastrada</h3></div>)
                    }
                </div>
                <ConfirmDialog/>
            </CustomView>
        </>
);
}

export default RestauranteCardapioBebidaImagemEdit;